<template>
  <path d="M12 8.6252L18 14.6252L16.925 15.7002L12 10.7502L7.075 15.6752L6 14.6002L12 8.6252Z" />
</template>
